import React from 'react'

export const DotSpan = (): JSX.Element => (
  <span aria-roledescription="separator">{' • '}</span>
)
